<template>
  <div class="mt-2">
    <BSpinner
      v-if="loading === true"
      label="Loading pending actions..."
    ></BSpinner>
    <div
      v-else-if="pendingActions && pendingActions.length === 0"
      class="text-center text-muted"
    >
      <IconAlertTriangle class="me-1 text-warning" />
      <br />
      No pending actions found.
    </div>
    <ul v-else class="list-group">
      <li
        v-for="pa in sortedPendingActions"
        :key="pa.uid"
        class="list-group-item d-flex align-items-center"
        :class="{ fulfilled: pa.fulfilled === 'true' }"
        style="cursor: pointer"
        @click="handleEdit(pa)"
      >
        <!-- Left side (date + icon) -->
        <div class="me-2 text-nowrap">
          <p class="mb-0">
            <small class="text-muted">{{ pa.created_date.slice(-5) }}</small>
          </p>
          <IconSquareCheck
            v-if="pa.fulfilled === 'true'"
            size="18"
            class="text-success"
          />
          <IconSquare v-else size="18" />
        </div>

        <!-- Content -->
        <div>
          <small>{{ pa.content }}</small>
        </div>
      </li>
    </ul>
    <EditPendingActionModal
      v-if="acctUid && selectedPendingAction"
      v-model="editModal"
      :acctUid="acctUid"
      :pendingAction="selectedPendingAction"
      @pendingActionEdited="fetchPendingActions(true)"
    />
  </div>
</template>
<script>
import { pendingActions as pendingActionsNs } from "@/store/namespaces";
import {
  IconAlertTriangle,
  IconSquareCheck,
  IconSquare,
} from "@tabler/icons-vue";
import { BSpinner } from "bootstrap-vue-next";
import EditPendingActionModal from "@/components/PendingActions/EditPendingActionModal.vue";

export default {
  name: "PendingActionsListView",
  components: {
    BSpinner,
    IconAlertTriangle,
    IconSquareCheck,
    IconSquare,
    EditPendingActionModal,
  },
  props: {
    acctUid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      editModal: false,
      selectedPendingAction: null,
    };
  },
  computed: {
    pendingActions() {
      return this.$store.getters[`${pendingActionsNs}/getPendingActions`];
    },
    sortedPendingActions() {
      if (!this.pendingActions) {
        return [];
      }

      // If a pending action is fulfilled, we want to sort it to the bottom of the list; otherwise, we want to sort by created date descending
      const sorted = this.pendingActions.slice().sort((a, b) => {
        if (a.fulfilled === "true" && b.fulfilled !== "true") {
          return 1; // a goes after b
        } else if (a.fulfilled !== "true" && b.fulfilled === "true") {
          return -1; // a goes before b
        } else {
          // If both are fulfilled or both are not fulfilled, sort by created date descending
          return new Date(b.created_date) - new Date(a.created_date);
        }
      });
      return sorted;
    },
  },
  async mounted() {
    await this.fetchPendingActions();
  },
  watch: {
    // Make sure to refetch transactions when the selected account changes
    acctUid(newAcctUid, oldAcctUid) {
      if (newAcctUid !== oldAcctUid) {
        this.fetchPendingActions();
      }
    },
  },
  methods: {
    handleEdit(pendingAction) {
      this.selectedPendingAction = pendingAction;
      setTimeout(() => {
        this.editModal = true;
      }, 100);
    },
    async fetchPendingActions(force = false) {
      try {
        this.loading = true;

        const params = {
          filter: [
            `acctUid:eq:${this.acctUid}`,
            `fulfilled:eq:false`,
            // `createdDate:gte:${this.startDate}`,
            // `createdDate:lte:${this.endDate}`,
          ],
        };

        await this.$store.dispatch(`${pendingActionsNs}/fetchPendingActions`, {
          qryParams: params,
          force,
        });
      } catch (error) {
        console.error("Error fetching pending actions:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
/*Create a class to somehow display when a pending action is fulfilled*/
.fulfilled {
  color: #6c757d; /* Gray text */
  opacity: 0.6; /* Slightly transparent */
  background-color: #f8f9fa; /* Light background */
}
</style>
